module.exports = __webpack_public_path__ + "img/1.9c3a59be.png";